class WebinarDTO {
    constructor(params) {
        this.id = params._id;
        this.version = params._version;
        this.externalId = params.externalId;
        this.rank = params.rank;
        this.description = params.description;
        this.dateTime = params.dateTime;
        this.rightTopHeader = params.rightTopHeader;
        this.rightImage = params.url + params.rightImage;
        this.url = params.url;
        this.link = params.link;
        this.title = params.title;
    }
}
export default WebinarDTO;
